import { render, staticRenderFns } from "./myFamily.vue?vue&type=template&id=339fe034&scoped=true&"
import script from "./myFamily.vue?vue&type=script&lang=js&"
export * from "./myFamily.vue?vue&type=script&lang=js&"
import style0 from "./myFamily.vue?vue&type=style&index=0&id=339fe034&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339fe034",
  null
  
)

export default component.exports